/********************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2021, 2024
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} **/

import { renderSnippet as renderKafkaSnippet } from './kafka';
import { apiTypes } from './constants';

const snippetFactory = (apiType) => {
  switch (apiType) {
    case apiTypes.kafka: {
      return renderKafkaSnippet;
    }
    default: {
      throw new Error(`${apiType} is not supported`);
    }
  }
};

export { snippetFactory };
